import { FilterChip } from '@marqvision/shared';
import { MarqCommonEnumsAiClientTagEnum } from '~/swagger/data-contracts';
import { useLogger } from '~/hooks';
import { getListingTabGroup } from '~/utils';
import { ResponsiveProps } from '~/components/Responsive/@types';
import { useGetFilterParams, usePathParams } from './@hooks';
import { TAG_FILTER_LABEL } from './@constants';

export const ReportedByUserFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const { requestFilterParams, setParams } = useGetFilterParams();
  const { client_requested_filter: reportedByUser } = requestFilterParams;
  const { page, listingStatus } = usePathParams();

  const { amplitudeLogging } = useLogger();
  const handleChange = () => {
    const newState = !reportedByUser;
    if (newState) {
      amplitudeLogging('applied filter', {
        Type: 'priority',
        Channel: page,
        Page: getListingTabGroup(listingStatus),
      });
    }
    setParams({
      requested: !reportedByUser,
    });
  };

  return (
    <FilterChip
      size={size}
      type="toggle"
      selected={!!reportedByUser}
      label={TAG_FILTER_LABEL[MarqCommonEnumsAiClientTagEnum.ClientRequested]}
      onClick={handleChange}
    />
  );
};
